import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { Tab, TabLabel } from 'components/Tabs';
import { bem } from 'helpers/class-name';

import { ModifierLibrary } from 'features/Sku/Modifiers';
import SkuVenueOpenStatus from '../shared/SkuVenueOpenStatus';
import messages from './SkuMenuPage.messages';
import { SKU_MODIFIERS_TAB } from './useSkuMenuState';

const { element } = bem('items');

// A render helper (not a component) because Tabs reads name/children off its immediate
// children; whether the tab renders at all is decided by the caller's venue gate.
const renderModifiersTab = ({ venueId }) => (
  <Tab name={SKU_MODIFIERS_TAB}>
    <TabLabel>
      <Message message={messages.modifiersTab} />
    </TabLabel>
    <div className={element('venue-status-row')}>
      <SkuVenueOpenStatus />
    </div>
    <ModifierLibrary venueId={venueId} />
  </Tab>
);

renderModifiersTab.propTypes = {
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default renderModifiersTab;
